
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import Helpers from "../../../helpers/helperFunctions";
import PropTypes from "prop-types";
import FavoritesMixin from "../../../mixins/favoritesMixin";
import Config from "../../../config/main";
import {t} from "../../../helpers/translator";
class Market extends Component {
    constructor (props) {
        super(props);
        this.setFavoritesMarket = this.setFavoritesMarket.bind(this);
        this.showNotification = this.showNotification.bind(this);
    }

    setFavoritesMarket (marketName) {
        return (ev) => {
            this.props.toggleMarketFavorite(marketName)();
            ev.stopPropagation();
            ev.preventDefault();
        };
    }
    showNotification (market) {
        const finded = market.find(item => Config.marketsNofitication.includes(item.market_type));
        return finded && t(`${finded.market_type}_info`);
    }
    shouldComponentUpdate (nextProps) {
        let allowRender = (JSON.stringify(nextProps.market) !== JSON.stringify(this.props.market) || (nextProps.isFavoritesMarket !== this.props.isFavoritesMarket));
        return allowRender;
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

Market.propTypes = {
    market: PropTypes.array,
    toggleMarketFavorite: PropTypes.func,
    isFavoritesMarket: PropTypes.bool,
    index: PropTypes.number
};

const mapStateToProps = (_, ownParams) => {
    let { selectorKey, marketName } = ownParams;
    return createSelector(
        [
            state => state.gameMarketsList[selectorKey] && JSON.stringify((() => {
                let market;
                Helpers.objectToArray(state.gameMarketsList[selectorKey]).forEach((marketGroup) => {
                    if (marketGroup[marketName]) {
                        market = marketGroup[marketName];
                    }
                });
                return market;
            })()),
            state => state.favorites.marketType?.[marketName]
        ],
        (market, isFavoritesMarket) => {
            return {
                market: market && JSON.parse(market),
                isFavoritesMarket
            };
        });
};

export default connect(mapStateToProps)(FavoritesMixin({Component: Market}));
